import React from "react";
import { Phone } from "lucide-react";

export default function MobileCallBar({ t }) {
  return (
    <a
      href={`tel:${t.phone.tel}`}
      data-testid="mobile-call-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-brand-accent text-white flex items-center justify-center gap-2.5 py-3.5 font-display font-black text-base shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.4)] safe-bottom active:bg-[color:var(--color-accent-hover)]"
    >
      <Phone className="w-5 h-5" strokeWidth={2.5} />
      <span className="tracking-tight">
        {t.mobile.callNow}: {t.phone.display}
      </span>
    </a>
  );
}
